import { render, staticRenderFns } from "./ManageCorals.vue?vue&type=template&id=a86de998&scoped=true"
import script from "./ManageCorals.vue?vue&type=script&lang=js"
export * from "./ManageCorals.vue?vue&type=script&lang=js"
import style0 from "./ManageCorals.vue?vue&type=style&index=0&id=a86de998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86de998",
  null
  
)

export default component.exports